import { formatCnpj, validateCnpj } from './cnpjUtils';
import { formatCpf, validateCpf } from './cpfUtils';

/** Keeps letters and digits only (CNPJ alphanumeric-safe). */
export const cleanDocumentAlnum = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[^a-zA-Z0-9]/g, '');
};

/**
 * Live/input formatting:
 * - digits only up to 11 → CPF mask
 * - letters or more than 11 chars → CNPJ mask (numeric or alphanumeric)
 */
export const formatDocumentNumberInput = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  const raw = String(value);
  const alnum = cleanDocumentAlnum(raw).toUpperCase();
  if (!alnum) return '';

  const hasLetters = /[A-Z]/.test(alnum);
  if (hasLetters || alnum.length > 11) {
    return formatCnpj(alnum);
  }
  return formatCpf(alnum);
};

/** True when value is a complete valid CPF (11 digits) or CNPJ (14 alphanumeric). */
export const validateDocumentNumber = (value: string | number | null | undefined): boolean => {
  if (value === null || value === undefined) return false;
  const alnum = cleanDocumentAlnum(value).toUpperCase();
  if (alnum.length === 14) return validateCnpj(alnum);
  if (/^\d{11}$/.test(alnum)) return validateCpf(alnum);
  return false;
};
